touchKit.ComponentManager.addHandler("externalLink", (data) => {


  var url = data.url || data.externalUrl;

  if (url.includes("mailto:")) {
    window.location.href = url;

    touchKit.TrackingManager.track(
      touchKit.TrackingManager.events.CONTENT_CLICKED,
      {
        type: "mailto",
        data: {
          url: url,
        },
      }
    );
  } else {
  
    url = url.includes("http") ? url : "http://" + url;

    touchKit.TrackingManager.track(
      touchKit.TrackingManager.events.CONTENT_CLICKED,
      {
        type: "externalLink",
        data: {
          url: url,
        },
      }
    );

    window.open(url, data.target);
  }
});


touchKit.ComponentManager.addHandler("internalLink", (data) => { 
  app.vm.$router.push(data.route.replace(/\{root\}/, app.defaultRoute));
})
